const genericSortByLocaleCompareFn = (a?: any, b?: any): number =>
	String(a || "").localeCompare(String(b || ""));
const genericSortByLocaleComparePropertyFn =
	<T>(key: keyof T) =>
	(a: T, b: T) =>
		genericSortByLocaleCompareFn(a?.[key], b?.[key]);

export const sortByPropertyAlphabetic = <T>(property: keyof T) =>
	genericSortByLocaleComparePropertyFn(property);
export const sortByPropertiesAlphabetic = <T>(properties: (keyof T)[]) => {
	return (a: T, b: T) =>
		properties.reduce((sort, prop) => sort || sortByPropertyAlphabetic(prop)(a, b), 0);
};

export const sortArrayWith =
	<T>(fn: (a: T, b: T) => number) =>
	(arr: T[]) =>
		arr.sort(fn);
